import React, {
  useReducer,
  useState,
  useEffect,
  createContext,
  useContext,
} from "react";
import fetchApi from "../fetchApi";
import AuthContext from "./auth";

const ProfileContext = createContext();
export default ProfileContext;

export const useProfile = () => useContext(ProfileContext);

export const ProfileContextProvider = ({ children }) => {
  const [errors, setError] = useReducer(reduceError, []);
  const [saved, setSaved] = useState();
  // Get user info from Auth context
  const { user, authState, setUser, login } = useContext(AuthContext);
  // Init state for modified data on profile
  const [data, setData] = useReducer(reduceData, {});

  // When auth is ready, set email field in profile data
  useEffect(() => {
    if (authState && user) {
      setData({ field: "email", value: authState.user_email });
      setData({ field: "skill", value: user.skill });
    }
  }, [authState, user]);

  // Display "saved!" button for a small time
  useEffect(() => {
    if (saved) setTimeout(() => setSaved(false), 1200);
  }, [saved]);

  // Send profile modifications to backend
  const save = async () => {
    setError();
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key === "password_old" && !data["password"]) return;
      const value = data[key]?.value || data[key];
      if (value !== user[key]) formData.append(key, value);
    });

    const result = await fetchApi(
      `/users/${user.id}?slug=${user.slug}`,
      {
        method: "post",
        body: formData,
      },
      false
    );
    if (result.hasOwnProperty("data") && result.data.status !== 200) {
      setError({ message: "Can't save user information" });
      return false;
    }

    if (data["email"]) login(data["email"], data["password_old"]);

    setUser(result);
    setSaved(true);
    return result;
  };

  return (
    <ProfileContext.Provider
      value={{
        data: { ...user, ...data },
        setData,
        save,
        saved,
        errors,
        setError,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

/*
 * action:
 * - {field: <string>, value: <any>}: Ajout d'une entrée
 * - {field: <string>, type: "remove"}: Supprimer une entrée
 */
const reduceData = (state, action) => {
  switch (action.type) {
    case "remove":
      const { [action.field]: _, ...newState } = state;
      return newState;
    case "skill":
      const { skill = [] } = state;
      if (!Array.isArray(skill)) return { ...state, skill: [action.value] };
      if (skill.includes(action.value))
        return {
          ...state,
          skill: skill.filter(id => id !== action.value),
        };
      else return { ...state, skill: [...skill, action.value] };
    default:
      return { ...state, [action.field]: action.value };
  }
};

const reduceError = (state, action) =>
  action ? [...state, { ...action }] : [];
